import React from 'react'
import about2 from '../Image/about2.avif'
import video2 from '../Image/video2.mp4'
import About_card from './About_card'

function Seconde_Component() {
  return (
    <div>
{/* ------------------------Mobile View-------------------------------- */}
    <div className='container-fluid d-sm-block  d-md-none'>
        <div className='px-3'>
            <div className=' d-flex justify-content-evenly px-2'>
            <About_card/>
            </div>
        </div>
    </div>
{/* ------------------------Dasktop View-------------------------------- */}
    <div className='container-fluid mb-4 d-none d-md-block'>
        <div className='mt-2'>
            <div className=' d-flex justify-content-evenly'>
            <About_card/>
            </div>
        </div>
    </div>
    </div>
  )
}

export default Seconde_Component
